import React from "react";
import _ from "lodash";
import AssetManager from "../../managers/AssetManager";
import TalkerFrame from "./TalkerFrame";
import StyleUtils from "../../utils/StyleUtils";
import WidgetConfig from "../../config/widget";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { DESIGN_CONTEXT } from "../../constants/DesignContextConstants";
import AppConstants from "../../constants/AppConstants";

export const getData = (props) => {
  const { content, elemProps, layout, theme } = props;
  const data = {
    layout,
    builder: true,
    config: {},
  };

  const galWidth = elemProps.get("w");
  const columns = elemProps.getIn(["gallery", "cols"], 3);
  const imgPad = elemProps.getIn(["gallery", "imgPad"], 0);
  const imgBorder = elemProps.getIn(["gallery", "imgBorder"]);

  data.config.cols = columns;
  data.config.imgPad = imgPad;

  if (imgBorder) {
    const borderInfo = imgBorder.toJS();
    if (_.has(borderInfo, "c")) {
      borderInfo.c = StyleUtils.getColorValue(borderInfo.c, theme);
    }
    if (borderInfo?.rad) {
      borderInfo.rad = String(borderInfo.rad);
    }
    data.config.imgBorder = borderInfo;
  }

  const items = content.get("items", false);
  const imageSize = AssetManager.determineSize(galWidth / columns);
  const images = [];
  const designContext = elemProps.get(DESIGN_CONTEXT);
  const { generateDesignAssetUrl } =
    DesignContextUtils.fromContext(designContext);

  items.forEach((image) => {
    const key = image.get("key");
    const op =
      key.endsWith(AppConstants.EXT_GIF) || key.endsWith(AppConstants.EXT_SVG) ? "file" : imageSize;
    const url = generateDesignAssetUrl({ key, op, provider: image.get("provider") });

    images.push({ sm: url });
  });

  data.images = images;

  return data;
};

const GalleryTiledWidget = (props) => (
  <TalkerFrame data={getData(props)} src={WidgetConfig.tiledGallery.url} />
);

export default GalleryTiledWidget;
